/**
 * What to call a column in the settings UI.
 *
 * A column seeded without a display name -- the vehicle lists do this -- is
 * shown under the frontend's own translated header, so it stays translated
 * until a company deliberately renames it.
 */
export function dynamicColumnLabel(
  column: { name: string; displayName: string },
  labels?: ReadonlyMap<string, string>
): string {
  return column.displayName || labels?.get(column.name) || column.name
}
